import { useLocation } from '@reach/router';
import { useEffect, useState } from 'react';

interface IEventKey {
  component_id?: string;
  id: string;
}

export const useActiveKey = (list?: IEventKey[]) => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState<string>();

  useEffect(() => {
    if (!location?.hash || !list || list.length === 0) {
      return;
    }

    const hash = location.hash.replace('#', '');
    const newActiveKey = list.find(item => item?.component_id === hash)?.id;

    if (newActiveKey) setActiveKey(newActiveKey);
  }, [list, location.hash]);

  return { activeKey, setActiveKey };
};
